import React from 'react';
import { string, func } from 'prop-types';

import Illustration from 'foundations/Illustrations/Illustration';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './HubCard.css';

const HubCard = ({ title, description, illustration, link, onClick }) => (
  <div className={styles.card}>
    <Illustration
      customClasses={styles.illustration}
      name={illustration}
      size="120" 
    />
    <p className={styles.title}>{title}</p>
    <p className={styles.description}>{description}</p>
    <LinkFreeStanding
      className={styles.link}
      icon={{ direction: 'right', name: 'link-arrow-right-17', type: 'other' }}
      size="s"
      withBouncing
      onClick={onClick}
    >
      {link}
    </LinkFreeStanding>
  </div>
);

HubCard.propTypes = {
  title: string,
  description: string,
  illustration: string,
  link: string,
  onClick: func
};

HubCard.displayName = 'HubCard';

export default  HubCard;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HubBanner/HubCard/HubCard.js